export default __webpack_public_path__ + "static/media/noa-35.71182be4.jpg";